declare namespace $ {

	export class $mol_icon_magnify_minus extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=minus.view.tree.d.ts.map